module.exports = __webpack_public_path__ + "static/media/calendar-clinic.ac25ce27.svg";